<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:按钮
-->
<template>
  <div class="carDetail" @mouseenter="handleEnter" @mouseleave="handleLeave">
    <div class="centerImg">
      <img v-if="base64Url" :src="base64Url" />
      <h-car-plate
        v-if="plateColor.length > 0"
        class="plateNo"
        :type="itemInfo.plateColor"
        v-model:colorData="plateColor"
      >
        {{ itemInfo.plateNo == "" ? "暂无车牌" : itemInfo.plateNo }}
      </h-car-plate>
    </div>
    <!-- <div class="hidClass" v-show="showHitClass">
      <i class="iconfont icon-icon-test"></i>
      <i class="iconfont icon-xiaoxi"></i>
      <i class="iconfont icon-shanchu"></i>
    </div> -->
    <div class="centerTitle">
      <div class="center-title-time">{{ itemInfo.passTime }}</div>
      <div class="center-title-name">{{ itemInfo.deviceName }}</div>
    </div>
  </div>
</template>
<script >
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  useSlots,
  watchEffect,
} from "vue";
import { addrTrans } from "@/api/smartApplication/personSearchApi.js";
export default defineComponent({
  name: "carDetail",
  components: {},
  props: {
    itemInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    plateColor: {
      type: Object,
      default: () => {
        return [];
      },
    },
  },
  setup(props) {
    const data = reactive({
      showHitClass: false,
      base64Url: "",
    });
    const refData = toRefs(data);

    watchEffect(() => {
      let url = props.itemInfo.vehicleUrl;
      nextTick(() => {
        urlToBase64(url);
      });
    });
    const handleEnter = () => {
      data.showHitClass = true;
    };
    const handleLeave = () => {
      data.showHitClass = false;
    };
    const urlToBase64 = async (url) => {
      const path = {
        paths: [url],
      };
      const res = await addrTrans(path);
      data.base64Url = res.data;
    };
    return { ...refData, handleLeave, handleEnter };
  },
});
</script>
<style  lang='scss' scoped >
.carDetail {
  width: 287px;
  height: 262px;
  border-radius: 8px;
  margin: 10px;
  color: #fff;
  position: relative;
  background-color: #294a7c;
  .centerTitle {
    height: 60px;
    text-align: center;
    .carplateNo {
      background: #36c13c;
      width: 100px;
      height: 30px;
      line-height: 30px;
      border-radius: 4px;
      margin: 0 5px;
    }
  }
  .centerImg {
    width: 100%;
    height: 65%;
    margin: 15px 0;
    position: relative;
    @include flex-col-c-c;
    img {
      width: 100%;
      height: 100%;
      border-radius: 4px 4px 0 0;
    }
    .plateNo {
      position: absolute;
      bottom: 0;
    }
  }
  .hidClass {
    position: absolute;
    width: 47px;
    right: 0;
    top: 0;
    height: 65%;
    background-color: #333;
    opacity: 0.8;
    margin: 15px 0;
    pointer-events: auto;
    @include flex-col-c-c;
    :nth-child(2) {
      margin: 8px 0;
    }
  }
}
</style>